import '@/components/image-slider/styles.scss';

import initSlider from '@/components/image-slider';
import initProductGridSlider from '@/components/product-grid-slider';

import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', () => {
  initSlider();
  initProductGridSlider();
});

